import { SVGProps } from 'react'

export const Bell = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="36" fill="none" viewBox="0 0 37 36" {...props}>
    <rect width="36" height="36" x="0.94" fill="currentColor" fillOpacity="0.08" rx="18"></rect>
    <path
      fill="currentColor"
      d="M18.941 26.125c.917 0 1.667-.75 1.667-1.667h-3.334c0 .917.742 1.667 1.667 1.667zm5-5v-4.167c0-2.558-1.366-4.7-3.75-5.266v-.567c0-.692-.558-1.25-1.25-1.25-.691 0-1.25.558-1.25 1.25v.567c-2.391.566-3.75 2.7-3.75 5.266v4.167L12.866 22.2c-.525.525-.158 1.425.584 1.425h10.974c.742 0 1.117-.9.592-1.425l-1.075-1.075z"
    ></path>
  </svg>
)
